import { useSelector } from "react-redux";
import { StoreType } from "../../../core/store/reducers";
import { UserMenuItem } from "../../models";

export const useUserMenuItems = () => {
	const menuItems = useSelector<StoreType, UserMenuItem[]>(store => store.data.initialData.userMenu);

	return [menuItems] as [typeof menuItems];
};
